export default {
    state: {
        routerToFromDict: {},
    },
    actions: {
    },
    mutations: {
        // updateRouterDict(state, fromRouter, toRouter) {
        //     state.routerToFromDict[toRouter.fullPath] = fromRouter
        // }
    },
    getters: {
    //     getPreviousRouter(state, currentRouter) {
    //         return state.routerToFromDict[currentRouter.fullPath]
    //     }
    }
}